import { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useTitleContext } from '../store/Page/TitleContext';
import StatusPageLayout from './StatusPageLayout';

interface RouteStatusPageProps {
    title: string;
    message: string;
}

const RouteStatusPage: FC<RouteStatusPageProps> = ({ title, message }) => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { onChange: changeTitle } = useTitleContext();

    // Reflect the status (e.g. "Page not found", "Access denied") in the tab.
    useEffect(() => {
        changeTitle(title);
        return () => changeTitle(undefined);
    }, [changeTitle, title]);

    return (
        <StatusPageLayout title={title} message={message}>
            <Button variant="contained" onClick={() => navigate('/dashboard')}>
                {t('nav.backToDashboard')}
            </Button>
        </StatusPageLayout>
    );
};

export default RouteStatusPage;
